// extracted by mini-css-extract-plugin
export var lbContainerOuter = "C_vp";
export var lbContainerInner = "C_vq";
export var movingForwards = "C_vr";
export var movingForwardsOther = "C_vs";
export var movingBackwards = "C_vt";
export var movingBackwardsOther = "C_vv";
export var lbImage = "C_vw";
export var lbOtherImage = "C_vx";
export var prevButton = "C_vy";
export var nextButton = "C_vz";
export var closing = "C_vB";
export var appear = "C_vC";